import { Reducer } from 'redux';

import {
    BrandColorsState,
    ActionTypes,
    BrandColorsLoadSuccessAction,
    BrandColorsAddSuccessAction,
    BrandColorsDeleteSuccessAction,
    BrandColorsEditSuccessAction,
} from './types';

const defaultState: BrandColorsState = {
    list: null,
    isLoading: false,
    isLoaded: false,
    isError: false,
};

const loadStart = (state: BrandColorsState): BrandColorsState => ({
    ...state,
    isLoading: true,
    isLoaded: false,
    isError: false,
});

const loadSuccess = (state: BrandColorsState, action: BrandColorsLoadSuccessAction): BrandColorsState => ({
    ...state,
    isLoading: false,
    isLoaded: true,
    isError: false,
    list: action.payload.colors,
});

const loadError = (state: BrandColorsState): BrandColorsState => ({
    ...state,
    isLoading: false,
    isLoaded: false,
    isError: true,
});

const addSuccess = (state: BrandColorsState, action: BrandColorsAddSuccessAction): BrandColorsState => ({
    ...state,
    list: action.payload.colors,
});

const editSuccess = (state: BrandColorsState, action: BrandColorsEditSuccessAction): BrandColorsState => ({
    ...state,
    list: action.payload.colors,
});

const deleteSuccess = (state: BrandColorsState, action: BrandColorsDeleteSuccessAction): BrandColorsState => ({
    ...state,
    list: action.payload.colors,
});

const reducer: Reducer<BrandColorsState> = (state: BrandColorsState = defaultState, action): BrandColorsState => {
    switch (action.type) {
        case ActionTypes.LOAD_START:
            return loadStart(state);
        case ActionTypes.LOAD_SUCCESS:
            return loadSuccess(state, action as BrandColorsLoadSuccessAction);
        case ActionTypes.LOAD_ERROR:
            return loadError(state);
        case ActionTypes.ADD_SUCCESS:
            return addSuccess(state, action as BrandColorsAddSuccessAction);
        case ActionTypes.EDIT_SUCCESS:
            return editSuccess(state, action as BrandColorsEditSuccessAction);
        case ActionTypes.DELETE_SUCCESS:
            return deleteSuccess(state, action as BrandColorsDeleteSuccessAction);
        default:
            return state;
    }
};

export { reducer as brandColors };

export default reducer;
